import React, { Component } from 'react';
import { Page, Text, View, Document, StyleSheet, PDFDownloadLink } from '@react-pdf/renderer';
import { Container, Avatar, Paper, Grid, Breadcrumbs, Link, Typography, TextField, Table, TableContainer, Button, TableHead, TableRow, TableBody, TableCell,IconButton} from '@material-ui/core';
import firestore from 'firebase';
import { consumerFirebase } from '../../config';
import Print from './Print';
// Create styles
const styles = StyleSheet.create({
  page: {
    flexDirection: 'row',
    backgroundColor: '#E4E4E4'
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1
  },
  cardGrid: {
    paddingLeft: "5em"

 },
 homeIcon: {
    width: 20,
    height: 20,
    marginRight: "4px"
 },
 link: {
    display: "flex",
 },
 gridTextField: {
    marginTop: "2em"
 },
 card: {
    height: "100%",
    display: "flex",
    flexDirection:"column"
 },
 cardMedia: {
    paddingTop: "56.25%"
 },
 cardContent: {
    flexGrow: 1
 },
 tablecontainer: {
    margin: "auto"
 },
 paper: {
    marginTop: "2em",
    paddingTop: "1em",
    paddingBottom: "2em",
    alignContent: "center",
    width: "100%"
 },
 avatarRestaurant: {
    width: 100,
    height: 100,
    paddingLeft: '6%',
 },
 print:{
     marginTop:'10%'
 }
});

// Create Document Component
class IndexUsers extends Component {
    state = {
        users: [],
        redirect: false,
        show: false
    }

    async componentDidMount(){
        let objectQuery = this.props.firebase.db.collection("Usuarios").orderBy("name");
  
        const snapshot = await objectQuery.get();
  
        const arrayProduct = snapshot.docs.map(doc => {
           let data = doc.data();
           let id = doc.id;
           return { id, ...data};
        })
  
        this.setState({
           users: arrayProduct,
           show: true
        })
    }


  
    render(){
        return (
            <Container style={styles.cardGrid} xs={12} md={8}>
                <Print style={styles.print}/>
                {/**<div id={this.props.printableId}>
                
                        <Grid container spacing={4}>
                            <Grid item xs={12} md={12}>
                                <Paper style={styles.paper} justify="center" elevation={4} xs={12} md={8}>
                                    <TableContainer style={styles.tablecontainer} justify="center">
                                        <Table style={styles.table} justify="center" aria-label="simple table">
                                        <TableHead style={styles.head}>
                                            <TableRow style={styles.row}>
                                                <TableCell align="center"></TableCell>
                                                <TableCell align="center">Nombre Completo</TableCell>
                                                <TableCell align="center">Email</TableCell>
                                                <TableCell align="center">Sexo</TableCell>
                                                <TableCell align="center">Edad</TableCell>
                                                <TableCell align="center">Ciudad</TableCell>
                                                <TableCell align="center"></TableCell>

                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {this.state.users.map(info => (
                                                <TableRow key={info.id}>
                                                    <TableCell align="center"></TableCell>
                                                    <TableCell align="center">{info.name + ' ' + info.fullname}</TableCell>
                                                    <TableCell align="center">{info.email}</TableCell>
                                                    <TableCell align="center">{info.sex}</TableCell>
                                                    <TableCell align="center">{info.age}</TableCell>
                                                    <TableCell align="center">{info.city}</TableCell>
                                                    <TableCell align="center"></TableCell>

                                                    <br></br>
                                                    
                                                </TableRow> 
                                            ))}                         
                                        </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Paper>
                            </Grid>   
                        </Grid>
            
                    </div>**/}

            </Container>
          );
    }
};

export default consumerFirebase(IndexUsers);